<div class="row audience-filters" (clickOutside)="onClickedOutside($event)" (exclude)="'.single-selected'">
  <div class="col-md-12 col-sm-12">
    <div class="header">{{'discover.search_bar.audience' | translate}}</div>
  </div>
  <div class="col-md-12 slider-container">
    <achoo-filter-box #genderFilterBox [options]="genderList"
                      [(model)]="audienceSearchCriteria.gender.value"
                      placeholder="{{'discover.search_bar.gender_placeholder' | translate}}"
                      multiple="true">
    </achoo-filter-box>
    <div class="slider-inner-container">
      <achoo-slider #genderRangeSlider [name]="'genderFilter'"
                    [min]="minValue" [max]="maxValue"
                    [from]="fromGender"
                    [to]="toGender"
                    [label]="'Share'"
                    [dataType]="'percent'"
                    [(model)]="audienceSearchCriteria.gender.range"></achoo-slider>
    </div>
  </div>
  <div class="col-md-12 slider-container">
    <achoo-filter-box #ageFilterBox [options]="ageRangeList"
                      [(model)]="audienceSearchCriteria.age.value"
                      placeholder="{{'discover.search_bar.age_placeholder' | translate}}"
                      multiple="true">
    </achoo-filter-box>
    <div class="slider-inner-container">
      <achoo-slider #ageRangeSlider [name]="'ageFilter'"
                    [min]="minValue" [max]="maxValue"
                    [from]="fromAge"
                    [to]="toAge"
                    [label]="'Share'"
                    [dataType]="'percent'"
                    [(model)]="audienceSearchCriteria.age.range"></achoo-slider>
    </div>
  </div>
  <div class="col-md-12 slider-container">
    <achoo-filter-box #countryFilterBox [options]="countryList"
                      [(model)]="audienceSearchCriteria.country.value"
                      placeholder="{{'discover.search_bar.country_placeholder' | translate}}"
                      multiple="true">
    </achoo-filter-box>
    <div class="slider-inner-container">
      <achoo-slider #countryRangeSlider [name]="'country'"
                    [min]="minValue" [max]="maxValue"
                    [from]="fromCountry"
                    [to]="toCountry"
                    [label]="'Share'"
                    [dataType]="'percent'"
                    [(model)]="audienceSearchCriteria.country.range"></achoo-slider>
    </div>
  </div>
  <div class="col-md-12">
    <div class="activity-filter-seperator"></div>
  </div>
  <div class="col-md-12 d-flex flex-row slider-container button-group">
    <button class="button gray" (click)="resetAudienceFilters()">{{'common.btn.reset' | translate}}</button>
    <div class="d-flex flex-auto"></div>
    <button class="button blue" (click)="doSearchByAudienceFilter()">{{'common.btn.save' | translate}}</button>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/discover/discover-search/audience-filter/audience-filter.component.html